import { Star } from "lucide-react";

export function StarRating({ value = 5, size = 14, showValue = true, testId }) {
  const full = Math.round(value);
  return (
    <div className="inline-flex items-center gap-1" data-testid={testId}>
      <div className="flex">
        {[1,2,3,4,5].map((i) => (
          <Star key={i} size={size} className={i <= full ? "fill-amber-400 stroke-amber-500" : "stroke-gray-300"} />
        ))}
      </div>
      {showValue && <span className="text-sm text-[#E5EAF2] ml-1 font-medium">{value.toFixed(1)}</span>}
    </div>
  );
}
